export default __webpack_public_path__ + "static/media/layout-type-filters-sidebar.729141ea.svg";